import { render, staticRenderFns } from "./Costos.vue?vue&type=template&id=9073eb0a&scoped=true&"
import script from "./Costos.vue?vue&type=script&lang=js&"
export * from "./Costos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9073eb0a",
  null
  
)

export default component.exports